import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const BackButton = ({ label = "Back", to }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (to) {
      navigate(to); // go specific page
    } else {
      navigate(-1); // go previous page
    }
  };

  return (
    <div className="flex flex-col items-start gap-3 mb-4">
      <button
        onClick={handleBack}
        className="w-9 h-9 flex items-center justify-center rounded-lg border hover:bg-gray-100 bg-white transition"
      >
        <ArrowLeft size={18} />
      </button>

      <span className="text-xl text-yellowstar animate-neonFlicker uppercase ml-3 ">
        {label}
      </span>
    </div>
  );
};

export default BackButton;
